import { Slide, Slider } from '$components/ui/slider';

import { ProjectImage } from './project-image';
import { ProjectTemplateProps } from '.';

export function ProjectSlider({ project }: ProjectTemplateProps) {
  const hasImages = project.images && project.images.length !== 0;

  if (!hasImages) {
    return (
      <ProjectImage
        image={project.thumbnail}
        alt={project.name}
        category={project.category}
      />
    );
  }

  const settings = {
    draggable: true,
    loop: true,
    navigation: true,
    pagination: { clickable: true },
    slidesPerView: 1,
    spaceBetween: 24,
  };

  return (
    <Slider settings={settings}>
      <>
        <Slide>
          <ProjectImage
            image={project.thumbnail}
            alt={project.name}
            category={project.category}
          />
        </Slide>

        {project.images?.map((image, index) => (
          <Slide key={image}>
            <ProjectImage
              image={image}
              alt={`${project.name} imagem número ${index}`}
              category={project.category}
            />
          </Slide>
        ))}
      </>
    </Slider>
  );
}
